/**
 * Diagram text measurement helpers.
 */
import { getActiveDiagram } from '../theme';
var measureCtx = null;
function getMeasureCtx() {
    if (typeof document === 'undefined')
        return null;
    if (!measureCtx) {
        var canvas = document.createElement('canvas');
        measureCtx = canvas.getContext('2d');
    }
    return measureCtx;
}
/** Measure label width using canvas text metrics (falls back to heuristic in Node). */
export function measureTextWidth(text, fontSize, fontWeight, fontFamily) {
    if (fontWeight === void 0) { fontWeight = '600'; }
    if (fontFamily === void 0) { fontFamily = getActiveDiagram().fontFamily; }
    var ctx = getMeasureCtx();
    if (!ctx)
        return text.length * fontSize * 0.55;
    ctx.font = "".concat(fontWeight, " ").concat(fontSize, "px ").concat(fontFamily);
    return ctx.measureText(text).width;
}
export function centerTextX(label, boxWidth, fontSize, fontWeight, fontFamily) {
    if (fontSize === void 0) { fontSize = getActiveDiagram().fontSize.base; }
    if (fontWeight === void 0) { fontWeight = '600'; }
    if (fontFamily === void 0) { fontFamily = getActiveDiagram().fontFamily; }
    var w = measureTextWidth(label, fontSize, fontWeight, fontFamily);
    return Math.max(getActiveDiagram().spacing.sm, (boxWidth - w) / 2);
}
